import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { dgWithReducer, DgContainer } from 'dg-utils';
import Swal from 'sweetalert2';
import { parse } from 'query-string';
import { useNavigate } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { dgInput, required, email } from 'dg-forms';
import { verifyPasswordReset } from './loginActions.mjs';
import loginReducer from './loginReducer.mjs';
import './types-0b7e03a3.js';
import '@babel/runtime/helpers/defineProperty';

var VerifyForm = function VerifyForm(props) {
  var handleSubmit = props.handleSubmit,
      pristine = props.pristine,
      submitting = props.submitting;
  return /*#__PURE__*/React.createElement("form", {
    className: "dg-login-form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Field, {
    name: "email",
    placeholder: "Email",
    type: "email",
    component: dgInput,
    validate: [required, email]
  }), /*#__PURE__*/React.createElement(Field, {
    name: "passwordResetToken",
    placeholder: "Password Reset Token",
    type: "text",
    component: dgInput,
    validate: [required]
  }), /*#__PURE__*/React.createElement(Field, {
    name: "newPassword",
    placeholder: "Password",
    type: "password",
    component: dgInput,
    validate: [required]
  }), /*#__PURE__*/React.createElement("div", {
    className: "field-group"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn-primary",
    disabled: pristine || submitting
  }, "Reset Password")));
};

var VerifyPasswordResetForm = reduxForm({
  form: 'VerifyForm' // a unique identifier for this form

})(VerifyForm);

function PasswordReset(props) {
  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      passwordResetToken = _useState2[0],
      setPasswordResetToken = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var navigate = useNavigate();
  useEffect(function () {
    var params = parse(window.location.search);

    if (params && params.token) {
      setPasswordResetToken(params.token);
    }

    if (params && params.email) {
      setEmail(params.email);
    }
  }, []);

  var onSubmit = function onSubmit(form) {
    props.verifyPasswordReset(form).then(function (res) {
      Swal.fire("Success!", res.message, "success");

      if (props.onSuccess) {
        props.onSuccess();
      } else {
        navigate("/admin");
      }
    })["catch"](function (res) {
      Swal.fire("Error!", res.message, "error");
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "dg-admin-login-container"
  }, /*#__PURE__*/React.createElement(DgContainer, {
    header: /*#__PURE__*/React.createElement("h2", null, "Reset Password"),
    content: /*#__PURE__*/React.createElement(VerifyPasswordResetForm, {
      onSubmit: props.onSubmit ? props.onSubmit : onSubmit,
      initialValues: {
        email: email,
        passwordResetToken: passwordResetToken
      },
      enableReinitialize: true
    })
  }));
}

PasswordReset.propTypes = {
  verifyPasswordReset: PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    verifyPasswordReset: function verifyPasswordReset$1(form) {
      return dispatch(verifyPasswordReset());
    }
  };
};

var verify = connect(mapStateToProps, mapDispatchToProps)(dgWithReducer(PasswordReset, "loggedInUser", loginReducer));

export { verify as default };
